import { render } from "./notas-turma_config.vue?vue&type=template&id=26d71a72&scoped=true"
import script from "./notas-turma_config.vue?vue&type=script&lang=js"
export * from "./notas-turma_config.vue?vue&type=script&lang=js"

import "./notas-turma_config.vue?vue&type=style&index=0&id=26d71a72&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26d71a72"]])

export default __exports__